/**
Checks if a number is between another two numbers, min and max.
If either min or max are falsey, defaults them to 0 or Infinity respectively.
 */
export default (number: number, min?: number, max?: number): boolean =>
  (min || 0) <= number && number <= (max || Infinity);
